export const mergeEmailSources = (
  ...sources: (string | string[] | null | undefined)[]
): string | null => {
  const emailSet = new Set<string>();

  sources.forEach(src => {
    if (!src) return;

    // Streng? Split på ; eller , i tilfelle bruker skrev flere manuelt
    if (typeof src === 'string') {
      src
        .split(/[;,]/)
        .map(e => e.trim())
        .filter(Boolean)
        .forEach(e => emailSet.add(e));
    } else if (Array.isArray(src)) {
      src
        .map(e => e.trim())
        .filter(Boolean)
        .forEach(e => emailSet.add(e));
    }
  });

  // Ingen funn ⇒ returner null, ellers joined streng
  return emailSet.size ? Array.from(emailSet).join(';') : null;
};
